import { ArrayField, ChipField, Show, SimpleShowLayout, SingleFieldList, TextField } from "react-admin";
import { YesNoBooleanField } from "../../fields/YesNoBooleanField";
import { ImageListField } from "../image/components/Field";

export function ProductShow(): JSX.Element {
    return (
        <Show>
            <SimpleShowLayout>
                <TextField source="name" />
                <TextField source="description" />
                <YesNoBooleanField source="singleContent" />
                <ArrayField source="characters">
                    <SingleFieldList linkType={false}>
                        <ChipField source="name" size="small" />
                    </SingleFieldList>
                </ArrayField>
                <ImageListField targetType="product" />
            </SimpleShowLayout>
        </Show>
    );
}
